<!--带一个图标和文字的按钮-->
<template>
	<div :class="['icoButton-body',buttonText==undefined ||buttonText.length == 0?'': 'icoButton-hasText']" @click="$emit('buttonClick')">
		<img :src="getLeftImage" />
		<span :class="[buttonText==undefined ||buttonText.length == 0?'': 'icoButton-span-hasText']">{{buttonText}}</span>
	</div>
</template>

<script type="text/javascript">
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		name: 'icoButton',
		components: {},
		props: {
			//图片当前皮肤下的完整路径名称
			icoName: {
				type: String,
			},
			//显示的文字
			buttonText: {
				type: String,
			}
		},
		data() {
			return {

			}
		},
		created() {},
		mounted() {},
		destroyed() {},
		computed: {
			getLeftImage() {
				return resourcesStore.getters.getResourcesByName(this.icoName)
			}
		},
		watch: {},
		methods: {}
	}
</script>

<style scoped>
	.icoButton-body {
		display: inline-flex;
		justify-content: space-between;
		align-items: center;
	}
		
	.icoButton-hasText{
		min-width: .5rem;
	}

	.icoButton-body span {
		font-size: .12rem;
		line-height: .2rem;
	}
	.icoButton-span-hasText{
		margin-left: .05rem;
	}

	.icoButton-body img {
		width: .18rem;
		height: .18rem;
	}
	.icoButton-body:active{
		background: rgba(0,0,0,0.1);
	}
</style>
